import { Box, Stack } from '@chakra-ui/react';
import Colors from '../../config/colors';
import { LazyLoadImage } from 'react-lazy-load-image-component';

export interface IPlatformListItem {
    name: string;
    imageURL: string;
    isSupported: string;
}

interface Props {
    platforms: IPlatformListItem[];
}

export default function PlatformList({ platforms }: Props) {
    return (
        <Box display="flex">
            {platforms.map((platform) => (
                <LazyLoadImage src={platform.imageURL} effect="blur" style={{ opacity: '0.5' }} />
            ))}
        </Box>
    );
}
